import React from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import s from './styles.module.scss'

type Props = {
  direction?: 'left' | 'right' | 'none'
}

const Tilt: React.FC<Props> = ({ direction, children }) => {
  return (
    <div
      className={cn({
        [s.tiltLeft]: direction === 'left',
        [s.tiltRight]: direction === 'right',
      })}
    >
      {children}
    </div>
  )
}

export default Tilt
